import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSwitch,
  CFormTextarea,
  CInputGroup,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import CIcon from '@coreui/icons-react'
import { cilBell, cilSend, cilTrash } from '@coreui/icons'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { getAppUsers } from 'src/redux/appusers'
import {
  deleteNotification,
  getNotificationData,
  sendNotification,
  sendNotificationToAll,
} from 'src/redux/notification'
import Pagination from 'react-js-pagination'

const Notification = () => {
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 100
  const [search, setSearch] = useState('')
  const [visibleLg, setVisibleLg] = useState(false)
  const [notification, setNotification] = useState([])
  const [setselectUser, setSetselectUser] = useState(true)
  const [select, setSelect] = useState({ label: '', value: '' })
  const [formData, setFormData] = useState({ title: '', body: '', user_code: '' })

  const dispatch = useDispatch()
  const { appUsers } = useSelector((state) => state.appusers)
  const { notificationData, errorNotificationData } = useSelector((state) => state.getnotification)

  useEffect(() => {
    dispatch(getAppUsers())
  }, [dispatch, loading])

  const filteredAppUsers = appUsers?.app_users?.filter((item) =>
    [item.username, item.mobile_no, item.name].some((field) =>
      field.toLowerCase().includes(search.toLowerCase()),
    ),
  )

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredAppUsers?.slice(indexOfFirstItem, indexOfLastItem)
  const totalItems = filteredAppUsers?.length || 0

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const handleSend = async () => {
    if (!formData.title || !formData.body) {
      toast('Title and Message required!', { type: 'info' })
      return
    }

    try {
      if (setselectUser) {
        dispatch(sendNotificationToAll({ title: formData.title, body: formData.body, data: {} }))
      } else {
        dispatch(
          sendNotification({
            title: formData.title,
            body: formData.body,
            token: select.value,
            data: { user_code: formData.user_code },
          }),
        )
      }

      setFormData({ title: '', body: '', user_code: '' })
      setSetselectUser(true)
    } catch (error) {
      toast(error.message, { type: 'error' })
    }
  }

  useEffect(() => {
    if (errorNotificationData) {
      setNotification([])
    } else {
      setNotification(notificationData?.notification)
    }
  }, [notificationData, errorNotificationData])

  const getNotification = (user_code) => {
    dispatch(getNotificationData(user_code))
    setVisibleLg(true)
  }

  const handleDelete = async (id, user_code) => {
    setLoading(true)
    try {
      await dispatch(deleteNotification(id))
    } finally {
      await dispatch(getNotificationData(user_code))
      setLoading(false)
    }
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={7}>
            <div className="d-flex justify-content-end mb-2">
              <CFormInput
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <PerfectScrollbar style={{ height: '80vh' }}>
              <CTable align="middle" className="mb-0 border" hover responsive>
                <CTableHead color="light">
                  <CTableRow>
                    <CTableHeaderCell className="text-center">
                      <CFormCheck
                        id="flexCheckChecked"
                        checked={setselectUser}
                        onChange={() => setSetselectUser(!setselectUser)}
                      />
                    </CTableHeaderCell>
                    <CTableHeaderCell>Username</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Mobile</CTableHeaderCell>
                    <CTableHeaderCell>View</CTableHeaderCell>
                    <CTableHeaderCell>Send</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {currentItems?.map((item, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell className="text-center">{index + 1})</CTableDataCell>
                      <CTableDataCell>
                        <div>{item.name}</div>
                        <div className="small text-medium-emphasis">
                          <strong>{item.username}</strong>
                        </div>
                      </CTableDataCell>
                      <CTableDataCell className="text-center">{item.mobile_no}</CTableDataCell>
                      <CTableDataCell>
                        <CButton
                          color="info"
                          size="sm"
                          onClick={() => getNotification(item.user_code)}
                        >
                          <CIcon icon={cilBell} className="text-white" />
                        </CButton>
                      </CTableDataCell>
                      <CTableDataCell>
                        <CButton
                          color="success"
                          size="sm"
                          onClick={() => {
                            setSelect({
                              label: `${item.name} - ${item.username}`,
                              value: item.fcm_token,
                            })
                            setFormData({ ...formData, user_code: item.user_code })
                            setSetselectUser(false)
                          }}
                        >
                          <CIcon icon={cilSend} className="text-white" />
                        </CButton>
                      </CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </PerfectScrollbar>
            <ul className="pagination justify-content-center mt-3">
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={totalItems}
                onChange={handlePageChange}
                pageRangeDisplayed={5}
                nextPageText="Next"
                prevPageText="Previous"
                lastPageText="Last"
                firstPageText="1st"
                itemClass="page-item"
                linkClass="page-link"
                activeClass="active"
                activeLinkClass="active"
              />
            </ul>
          </CCol>

          <CCol md={9} lg={7} xl={5}>
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <CForm>
                  <h6 className="mb-3">Send Notification</h6>
                  <CInputGroup className="mb-3">
                    {setselectUser ? (
                      <CFormSwitch
                        defaultChecked
                        value={setselectUser}
                        label="Send to all users"
                        disabled
                      />
                    ) : (
                      <CFormInput disabled value={select.label} />
                    )}
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CFormInput
                      placeholder="Enter Title"
                      value={formData.title}
                      onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CFormTextarea
                      placeholder="Message"
                      value={formData.body}
                      onChange={(e) => setFormData({ ...formData, body: e.target.value })}
                      rows={7}
                    />
                  </CInputGroup>
                  <div className="d-grid">
                    <CButton color="success" onClick={handleSend}>
                      Send
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>

        <CModal size="lg" visible={visibleLg} onClose={() => setVisibleLg(false)}>
          <CModalHeader>
            <CModalTitle>View Notification</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CTable align="middle" className="mb-0 border" hover responsive>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell className="text-center">Sr.</CTableHeaderCell>
                  <CTableHeaderCell>Title</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Message</CTableHeaderCell>
                  <CTableHeaderCell>Screen</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Delete</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {notification?.map((item, index) => (
                  <CTableRow key={index}>
                    <CTableDataCell className="text-center">{index + 1})</CTableDataCell>
                    <CTableDataCell>{item.title}</CTableDataCell>
                    <CTableDataCell className="text-center">{item.body}</CTableDataCell>
                    <CTableDataCell>{item.screen || '-'}</CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CButton
                        color="danger"
                        size="sm"
                        onClick={() => handleDelete(item.id, item.user_code)}
                      >
                        <CIcon icon={cilTrash} className="text-white" />
                      </CButton>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CModalBody>
        </CModal>
      </CContainer>
    </div>
  )
}

export default Notification
